export type DisplayAs = 'symbol' | 'code'
export type SymbolPosition = 'prefix' | 'suffix'
export type NegativeStyle = 'minus' | 'parens'
export type DecimalSep = ',' | '.'
export type ThousandsSep = '.' | ','

export interface CurrencyPrefs {
    code: string
    symbol: string
    displayAs: DisplayAs
    symbolPosition: SymbolPosition
    decimalSeparator: DecimalSep
    thousandsSeparator: ThousandsSep
    decimals: number
    negativeStyle: NegativeStyle
    locale: string
}

/** Shape sent to / received from the backend */
export interface CurrencyOverridesPayload {
    display?: DisplayAs
    display_position?: 'before' | 'after'
    decimal_separator?: string
    thousands_separator?: string
    decimal_places?: number
}

export interface CurrencyPayload {
    currency: string
    // locale: string
    currency_overrides: CurrencyOverridesPayload
}

export const CURRENCIES: {
    code: string
    symbol: string
    decimals: number
    label: string
}[] = [
    { code: 'EUR', symbol: '€', decimals: 2, label: 'Euro (EUR)' },
    { code: 'USD', symbol: '$', decimals: 2, label: 'US Dollar (USD)' },
    { code: 'GBP', symbol: '£', decimals: 2, label: 'British Pound (GBP)' },
    { code: 'JPY', symbol: '¥', decimals: 0, label: 'Japanese Yen (JPY)' },
    { code: 'CHF', symbol: 'CHF', decimals: 2, label: 'Swiss Franc (CHF)' },
]

export const DEFAULT_PREFS: CurrencyPrefs = {
    code: 'EUR',
    symbol: '€',
    displayAs: 'symbol',
    symbolPosition: 'prefix',
    decimalSeparator: ',',
    thousandsSeparator: '.',
    decimals: 2,
    negativeStyle: 'minus',
    locale: 'nl-NL',
}

export const PREVIEW_VALUES: { label: string; value: number }[] = [
    { label: 'Positive', value: 1_234.56 },
    { label: 'Negative', value: -1_234.56 },
    { label: 'Zero', value: 0 },
    { label: 'Large', value: 1_234_567.89 },
]

export const DECIMAL_OPTIONS: {
    value: DecimalSep
    label: string
    paired: ThousandsSep
}[] = [
    { value: ',', label: 'Comma  ,', paired: '.' },
    { value: '.', label: 'Period  .', paired: ',' },
]

export const THOUSANDS_OPTIONS: {
    value: ThousandsSep
    label: string
    paired: DecimalSep | null
}[] = [
    { value: '.', label: 'Period  .', paired: ',' },
    { value: ',', label: 'Comma  ,', paired: '.' },
]
